import { loadStripe } from '@stripe/stripe-js';
import getConfig from 'next/config';
import { currencies } from '../../constant';
import { createAuthorizationHeader, instanceFetch } from '../../fetch';
import { sortedArr } from '../../helper';

const {
  publicRuntimeConfig: { stripeKey },
} = getConfig();

export const getPrices = (locale) => {
  const currency = currencies[locale] || 'USD';

  return instanceFetch
    .get(`/prices?currency=${currency}`)
    .then((data) => {
      const sortedPrice = sortedArr(data);
      return sortedPrice;
    })
    .catch();
};

export const createCheckout = async (
  licenseLogin: string,
  licenseId: string,
  priceId,
  successUrl: string,
  cancelUrl: string,
  locale
) => {
  const stripe = await loadStripe(stripeKey);
  const currency = currencies[locale] || 'USD';
  const headers = createAuthorizationHeader();
  return instanceFetch
    .post(
      `/checkout/license`,
      { licenseLogin, licenseId, priceId, currency, successUrl, cancelUrl },
      headers
    )
    .then((sessionId) => {
      if (stripe) {
        stripe.redirectToCheckout({
          sessionId,
        });
      }
    })
    .catch((err) => {
      throw err;
    });
};

export const checkoutStatus = (status, sessionId) => {
  const headers = createAuthorizationHeader();
  const URL = `/checkout/${status}${sessionId ? `?sessionId=${sessionId}` : ''}`;
  return instanceFetch.get(URL, headers);
};

export const getNewCredentials = async (sessionId: string) => {
  const headers = createAuthorizationHeader();
  return instanceFetch
    .get(`/checkout/show-purchase?sessionId=${sessionId}`, headers)
    .then((res) => {
      return res;
    });
};

export type PaymentMethods = 'COIN_PAYMENTS' | 'CLOUD_PAYMENTS';

export const getPaymentMethods = async () => {
  const headers = createAuthorizationHeader();
  return instanceFetch.get<Array<PaymentMethods>>('/payments/methods', headers);
};

type GetInvoiceIdParams = {
  promoCode: string;
  licenseId: number;
  priceId: number;
  isExtension: boolean;
};

export const getInvoiceId = async ({
  promoCode,
  licenseId,
  priceId,
  isExtension,
}: GetInvoiceIdParams) => {
  const headers = createAuthorizationHeader();

  return instanceFetch
    .post<string>(
      '/payments',
      {
        paymentType: 'COIN_PAYMENTS',
        licenseId: licenseId && String(licenseId),
        isExtension,
        priceId,
        promoCode,
      },
      headers
    )
    .catch(console.error);
};
